<template>
  <div>
    <b-loading :is-full-page="true" v-model="isLoading"></b-loading>
    <label class="vs-input--label">{{ $t('companySelector.label') }} *</label>
    <TreeSelect
        :options="companies"
        :disable-branch-nodes="true"
        :show-count="true"
        :value="value"
        name="company"
        v-validate="'required'"
        :placeholder="$t('companySelector.placeholder')"
        :disabled="isDisable"
        @select="select"/>
  </div>
</template>

<script>
import TreeSelect from "@riophae/vue-treeselect";
import {getParameterByName} from "@/global/utils";
import {get as getProp} from "object-path";
import {SESSION_VARS} from "@/global/constants";
import CompanyEndpoint from "@/endpoints/core/CompanyEndpoint";

export default {
  name: "CompanySelector",
  components: {TreeSelect},
  props: ["value", "isDisable"],
  data: () => ({
    isLoading: true,
    companies: [],
    company: null,
  }),
  async mounted() {
    this.companies = await CompanyEndpoint.listCompanies()
    this.company = getParameterByName("companyId");
    if (!this.company) {
      this.company = localStorage.getItem(SESSION_VARS.CURRENT_COMPANY);
      this.selectCompany(this.company);
    }
    this.isLoading = false;
  },
  methods: {
    select(company) {
      const companyId = getProp(company, "code");
      this.selectCompany(companyId);
    },
    selectCompany(companyId) {
      if (companyId) {
        localStorage.setItem(SESSION_VARS.CURRENT_COMPANY, companyId);
      }
      this.$emit("input", companyId);
    }
  },
};
</script>
